export const ROOMS_ORDER_OPTIONS = [
  { id: 'newest', label: 'Newest', value: 'newest' },
  { id: 'popular', label: 'Most Popular', value: 'popular' },
  { id: 'duration-asc', label: 'Shortest Duration', value: 'duration-asc' },
  { id: 'duration-desc', label: 'Longest Duration', value: 'duration-desc' },
  { id: 'a-z', label: 'A-Z', value: 'a-z' },
  { id: 'z-a', label: 'Z-A', value: 'z-a' },
];
